import * as ActionTypes from './types.action';

export const setCurrentRoute = route => ({
  type: ActionTypes.SET_CURRENT_ROUTE_SUCCESS,
  route,
});
